import React from 'react'
import { connect } from 'react-redux'
import Joyride, { StoreHelpers } from 'react-joyride'
import {
  origins,
  UserClickPayload,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'

import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { TourBase } from './TourBase'
import * as Styled from './styled'
import * as TestIds from './testIds'
import { TourStep, TourConfigProps } from './types'
import { baseConfigProps } from './utils'

export interface TourProps {
  steps: TourStep[]
  tourConfigProps?: TourConfigProps
  stepIndex?: number
  onNext?: (index: number) => void
  onComplete?: () => void
  userClick: (payload: UserClickPayload) => void
}

const Tour: React.FC<TourProps> = ({
  steps,
  tourConfigProps = baseConfigProps,
  stepIndex,
  onNext,
  onComplete,
  userClick,
}) => {
  const [storeHelpers, setStoreHelpers] = React.useState<StoreHelpers>()
  const [internalStepIndex, setInternalStepIndex] = React.useState<number>(stepIndex || 0)
  const nextStepIndex = internalStepIndex + 1

  React.useEffect(() => {
    if (stepIndex !== undefined) {
      setInternalStepIndex(stepIndex)
      storeHelpers?.go(stepIndex)
    }
  }, [stepIndex])

  const handleComplete = () => {
    if (onComplete) {
      onComplete()
    }
  }

  const wrapTourContent = (content: React.ReactNode) => {
    return (
      <Styled.TourWrapper data-test={TestIds.TOUR_CONTAINER_TEST_ID}>
        <TourBase
          component={content}
          index={internalStepIndex}
          stepCount={steps.length}
          onNextClick={() => {
            userClick({ origin: origins.dashboardTourStep, step: nextStepIndex })
            setInternalStepIndex(nextStepIndex)
            if (onNext) {
              onNext(nextStepIndex)
            }
          }}
          onCloseClick={() => {
            userClick({ origin: origins.dashboardTourStep, step: nextStepIndex })
            setInternalStepIndex(nextStepIndex)
            storeHelpers.close()
            handleComplete()
          }}
        />
      </Styled.TourWrapper>
    )
  }

  const wrappedSteps = steps.map(({ content, ...rest }) => ({
    content: wrapTourContent(content),
    ...rest,
  }))

  return (
    <Joyride
      stepIndex={internalStepIndex}
      steps={wrappedSteps}
      getHelpers={setStoreHelpers}
      {...tourConfigProps}
    />
  )
}

const mapDispatchToProps = { userClick }

export default connect(null, mapDispatchToProps)(Tour)
